/**
 * 降低翻译迁移成本
 * copy @didi/gettext逻辑
 * 核心改造：数据源 po文件 -> 翻译中心自动同步数据源
 */
import emitter from '@/common/utils/emitter'
const packageJson = require('../../package.json')
const projectName = packageJson.name

const languages = {
  'en-US': 'American English',
  'zh-CN': '简体中文',
  'es-MX': 'Español',
  'pt-BR': 'Portuguese',
  'ja-JP': '日本語'
}

const checkLocale = locale => {
  var lowerCaseLocale = locale.toLowerCase()
  var localeArr = lowerCaseLocale.split('-')
  if (localeArr.length === 0) {
    return null
  }
  for (var i in languages) {
    var lang = i.split('-')[0]
    if (lang === localeArr[0]) {
      return i
    }
  }
  return null
}
// 获取顺序 locale 一级路径 => 本地语言
const getLocale = () => {
  var locale = null
  var path = location.pathname.split('/')[1]
  locale = checkLocale(path)
  if (!locale) {
    locale = checkLocale(window.navigator.language)
  }
  if (!locale) {
    locale = 'en-US'
  }
  return locale
}

class Jed {
  constructor (data) {
    this.data = data
  }

  _ (key) {
    if (this.data[key] === undefined) {
      emitter.emit('monitorTranslation', key, projectName)
    }
    return this.data[key] || key
  }

  gettext (key) {
    if (this.data[key] === undefined) {
      emitter.emit('monitorTranslation', key, projectName)
    }
    return this.data[key] || key
  }

  ngettext (singular, plural, count) {
    let key = ''

    if (plural === undefined || count === undefined) {
      key = singular
    } else if (count > 1) {
      key = plural
    } else {
      key = singular
    }
    return this.data[key] || key
  }

  // 未使用
  pgettext () {
  }
}

Jed.sprintf = require('sprintf-js').sprintf

class VueJed {
  constructor (langData) {
    const i18n = new Jed(langData)

    this.gettext = i18n.gettext.bind(i18n)
    this._ = this.gettext
    this.ngettext = i18n.ngettext.bind(i18n)
    this.pgettext = i18n.pgettext.bind(i18n)
    this.plugin = {
      install: (Vue, options) => {
        Vue.prototype._ = this.gettext
        Vue.prototype.gettext = this.gettext
        Vue.prototype.ngettext = this.ngettext
        Vue.prototype.pgettext = this.pgettext
      }
    }
  }
}

const sprintf = Jed.sprintf

export {
  getLocale,
  VueJed,
  sprintf,
  languages
}
